import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = 'lovable_device_id';
const SESSION_ID_KEY = 'lovable_session_id';

/**
 * Generate or retrieve a persistent device identifier
 */
export const getDeviceId = (): string => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  
  return deviceId;
};

/**
 * Generate a new session identifier for this browser session
 */
export const getSessionId = (): string => {
  let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
  
  if (!sessionId) {
    sessionId = uuidv4();
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }
  
  return sessionId;
};

/**
 * Get a unique identifier combining user, device, and session
 */
export const getUniqueSessionKey = (userId?: string): string => {
  const deviceId = getDeviceId();
  const sessionId = getSessionId();
  const userPart = userId || 'anonymous';
  
  return `${userPart}_${deviceId}_${sessionId}`;
};

/**
 * Get device-specific channel name for real-time subscriptions
 */
export const getDeviceChannelName = (baseName: string, userId?: string): string => {
  const deviceId = getDeviceId();
  const sessionId = getSessionId();
  const userPart = userId || 'anonymous';
  
  return `${baseName}_${userPart}_${deviceId}_${sessionId}`;
};

/**
 * Track session health with last activity timestamp
 */
export const updateSessionActivity = (): void => {
  const timestamp = Date.now();
  sessionStorage.setItem('last_activity', timestamp.toString());
};

/**
 * Check if session is stale (no activity for more than 5 minutes)
 */
export const isSessionStale = (): boolean => {
  const lastActivity = sessionStorage.getItem('last_activity');
  if (!lastActivity) return false;
  
  const timeSinceActivity = Date.now() - parseInt(lastActivity);
  return timeSinceActivity > 5 * 60 * 1000; // 5 minutes
};